var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgExpediaCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1230_2256)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1230_2256",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.27813 0 0 6.27812 0 14C0 21.7219 6.27813 28 14 28C21.7219 28 28 21.7219 28 14C28 6.27812 21.7219 0 14 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1230_2256)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2454 28H5.75457C2.58189 28 0 25.4184 0 22.235V5.75277C0 2.58156 2.58189 0 5.75457 0H22.2454C25.4303 0 28 2.58156 28 5.75277V22.235C28.0122 25.4184 25.4303 28 22.2454 28ZM22.959 20.2187V6.83364C22.959 5.83812 22.16 5.03944 21.164 5.03944H7.77268C7.50168 5.03944 7.34222 5.13786 7.16969 5.30944L4.50153 8.00162C4.3046 8.19846 4.43967 8.49285 4.73506 8.49285H16.8472L9.33419 16.0032C9.19913 16.1382 9.13726 16.2732 9.13726 16.4945V18.4742C9.13726 18.7076 9.29759 18.867 9.53112 18.867H11.5109C11.7444 18.867 11.8795 18.806 12.0023 18.6702L19.5162 11.1606V23.2671C19.5162 23.5624 19.8108 23.6974 20.0077 23.5006L22.7011 20.8215C22.8606 20.649 22.959 20.4896 22.959 20.2187Z",
    fill: "#FDDB32"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExpediaCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/expedia-circle.5b64521d.svg";
export { ForwardRef as ReactComponent };